import { globalState } from '@/components/helpers/utils'
import clsx from 'clsx'
import Icon from '@/components/snippets/icon/icon'

const getFilterDisplayCustomisations = (field) => {
  const filterMetaobject = globalState.metaobjects?.filters || []
  const relevantFilter = filterMetaobject.find((filter) => filter.athos_field === field)
  return relevantFilter || {}
}

const swatchInnerClasses =
  'swatch-inner mr-0.25 outline outline-1 outline-transparent group-hover/filter-item:outline-brand-black transition-all'

const ColorSwatch = ({ color }) => (
  <div
    className={clsx(swatchInnerClasses, 'size-1.5 rounded-full border border-borders-default')}
    style={{ backgroundColor: color }}
  />
)

const IconImage = ({ iconObject, width = 24 }) => {
  if (!iconObject) return null

  if (iconObject.icon) {
    const height = iconObject.aspectRatio ? width / iconObject.aspectRatio : width
    return <img src={iconObject.icon} alt="" width={width} height={height} className={swatchInnerClasses} />
  }

  if (iconObject.iconID) {
    return (
      <Icon
        id={iconObject.iconID}
        width={width}
        height={iconObject.aspectRatio ? width / iconObject.aspectRatio : width}
        className={swatchInnerClasses}
      />
    )
  }

  return null
}

export { getFilterDisplayCustomisations, ColorSwatch, IconImage }
